import { CalendarDay } from 'further-ui/utils';
import api from 'lib/trpcClient';
import { CapitalActionFormValues } from '../../hooks/useCapitalActionForm';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { round, sumBy } from 'lodash';

export default function useReviewDetails({
  capitalActionId,
  entries,
  vehicleId,
  date,
}: {
  capitalActionId?: string;
  entries: CapitalActionFormValues['entries'];
  vehicleId: string;
  date: CalendarDay;
}) {
  const { setValue } = useFormContext<CapitalActionFormValues>();

  const [{ transactionTypes, investorsBreakdown }] =
    api.capitalAction.getTransactionTypes.useSuspenseQuery({
      capitalActionId,
      vehicleId,
      entries,
      date,
    });

  useEffect(() => {
    setValue('transactions', transactionTypes);
  }, [transactionTypes]);

  const totalAmount = round(
    sumBy(entries, (entry) => {
      if (
        [
          CapitalActionEntryType.CapitalRefund,
          CapitalActionEntryType.CapitalDistribution,
        ].includes(entry.entryType)
      ) {
        return -entry.totalAmount;
      }

      return entry.totalAmount;
    }),
    2,
  );

  return {
    transactionTypes,
    investorsBreakdown,
    totalAmount,
  };
}
